<template lang="pug">
v-card(flat)
  v-card-title: .text-body-1: strong.mb-4 Мои реквизиты
  v-card-text
    api-form(
      ref="api-form"
      v-if="!loading"
      v-model="value"
      :fields="fields"
      :method="save"
      :initial="initial"
      :autosave="false"
      :successCallback="successCallback"
      :errorCallback="errorCallback"
      v-bind="$attrs"
    )
      template(#action v-if="cols")
        v-row
          v-btn(
            color="error"
            @click="backBtnEvent"
          ) Назад
          v-spacer
          v-btn(
            color="primary"
            @click="saveFromApiForm"
          ) Сохранить и продолжить
</template>

<script>
import { mapGetters } from 'vuex';
import HintWrap from '@/components/HintWrap.vue';
import FieldInn from '@/components/InputFields/FieldInn.vue';
import FieldBank from '@/components/InputFields/FieldBank.vue';
import AddressInput from '@/components/InputFields/AddressInput.vue';
import MaskaField from '@/components/InputFields/MaskaField.vue';

export default {
  name: 'CourseForm',
  components: { FieldInn },
  props: {
    cols: { type: Boolean, default: false },
    successCallback: { type: Function, default: () => {} },
    errorCallback: { type: Function, default: () => {} },
    backBtnEvent: { type: Function, default: () => {} },
  },
  data: () => ({
    treasury: null,
    resp: [],
    value: {
      legal_address: null,
      type: null,
      name: '',
      address: '',
      inn: null,
      bank_name: '',
      bank_cor_acc: '',
      kpp: '',
      oktmo: '',
    },
    loading: true,
    initial: null,
  }),
  computed: {
    ...mapGetters({ userOrganizations: 'auth/userOrganizations' }),
    fields() {
      return [
        {
          value: 'inn',
          text: 'ИНН',
          rules: 'required',
          component: FieldInn,
          component_attrs: {
            // type: 1,
          },
          component_events: {
            orgData: (data) => {
              const {
                kpp,
                oktmo,
                okpo,
                name,
                address,
              } = data;

              this.$set(this.value, 'kpp', kpp);
              if (this.value?.type === 2) this.$set(this.value, 'oktmo', oktmo);
              this.$set(this.value, 'recipient_name', name?.short_with_opf);
              this.$set(this.value, 'legal_address', address.value);
              this.$set(this.value, 'okpo', okpo);
            },
          },
        },
        ...this.value?.inn ? [
          {
            text: 'Наименование организации',
            value: 'recipient_name',
            rules: 'required',
            component: 'v-text-field',
            component_attrs: {
              outlined: true,
              filled: true,
              rounded: true,
            },
          },
          {
            text: 'Юридический адрес',
            value: 'legal_address',
            rules: 'required',
            component: HintWrap,
            component_attrs: {
              component: AddressInput,
              rounded: true,
              outlined: true,
              filled: true,
              returnString: true,
            },
          },
          {
            text: 'Номер телефона',
            value: 'phone',
            component: HintWrap,
            component_attrs: {
              component: MaskaField,
              rounded: true,
              outlined: true,
              filled: true,
              type: 'phone',
            },
          },
          {
            text: 'Почта',
            value: 'email',
            component: HintWrap,
            component_attrs: {
              component: 'v-text-field',
              rounded: true,
              outlined: true,
              filled: true,
            },
          },
          {
            text: 'КПП',
            value: 'kpp',
            component: HintWrap,
            component_attrs: {
              component: 'v-text-field',
              rounded: true,
              outlined: true,
              filled: true,
              type: 'number',
            },
          },
          {
            text: 'Тип счета',
            value: 'type',
            rules: 'required',
            component: HintWrap,
            component_attrs: {
              component: 'v-select',
              items: [{ value: 1, text: 'Счет в кредитной организации (Банке)' }, { value: 2, text: 'Счет в казначействе' }],
              rounded: true,
              outlined: true,
              filled: true,
              type: 'number',
            },
          },
          ...this.value?.type ? [

            {
              value: 'bic',
              text: 'БИК банка',
              component: FieldBank,
              component_attrs: {
                inn: this.value?.inn,
              },
              component_events: {
                bankData: (val) => {
                  if (this.value?.type === 2 && val.data.treasury_accounts) this.$set(this.value, 'eks', val.data.treasury_accounts[0]);

                  this.$set(this.value, 'bank_name', val.value);
                  this.$set(this.value, 'bank_cor_acc', val.data.correspondent_account);
                },
              },
            },
            {
              text: this.value?.type === 1 ? 'Банк' : 'Наименование УФК',
              value: 'bank_name',
              component: HintWrap,
              component_attrs: {
                component: 'v-text-field',
                rounded: true,
                outlined: true,
                filled: true,
              },
            },
            ...this.value?.type === 2 ? [{
              text: 'Лицевой счет',
              value: 'acc_personal',
              component: HintWrap,
              component_attrs: {
                component: 'v-text-field',
                rounded: true,
                outlined: true,
                filled: true,
              },
            }] : [],
            {
              text: 'Номер расчетного счета',
              value: 'acc',
              rules: 'max:20',
              component: HintWrap,
              component_attrs: {
                component: 'v-text-field',
                rounded: true,
                outlined: true,
                filled: true,
                type: 'number',
              },
            },
            ...this.value?.type === 1 ? [
              {
                text: 'Кор. счет',
                value: 'bank_cor_acc',
                rules: 'max:20',
                component: HintWrap,
                component_attrs: {
                  component: 'v-text-field',
                  rounded: true,
                  outlined: true,
                  filled: true,
                  type: 'number',
                },
              },
              {
                text: 'ОКПО',
                value: 'okpo',
                component: HintWrap,
                component_attrs: {
                  component: 'v-text-field',
                  rounded: true,
                  outlined: true,
                  filled: true,
                  type: 'number',
                },
              },
            ] : [
              {
                text: 'ЕКС',
                value: 'eks',
                component: HintWrap,
                component_attrs: {
                  component: 'v-text-field',
                  rounded: true,
                  outlined: true,
                  filled: true,
                  type: 'number',
                },
              },

              {
                text: 'КБК',
                value: 'kbk',
                component: HintWrap,
                component_attrs: {
                  component: 'v-text-field',
                  rounded: true,
                  outlined: true,
                  filled: true,
                  type: 'number',
                },
              },
              {
                text: 'ОКПО',
                value: 'okpo',
                component: HintWrap,
                component_attrs: {
                  component: 'v-text-field',
                  rounded: true,
                  outlined: true,
                  filled: true,
                  type: 'number',
                },
              },
              {
                text: 'ОКТМО',
                value: 'oktmo',
                component: HintWrap,
                component_attrs: {
                  component: 'v-text-field',
                  rounded: true,
                  outlined: true,
                  filled: true,
                  type: 'number',
                },
              },
            ],
          ] : [],
        ] : [],
      ];
    },
  },
  created() {
    this.getPayment();
  },
  methods: {
    saveFromApiForm() {
      this.$refs['api-form'].save();
    },
    async getPayment() {
      const { id } = this.userOrganizations[0];
      const { data } = await this.$api.contracts.getPayment(id);
      this.value = data.data?.payment_detail || {};
      this.loading = false;
    },
    save({ data, obs }) {
      const { id } = this.userOrganizations[0];
      const payloads = { ...data };

      return this.$api.contracts.updatePaymentDetail(id, payloads, obs);
    },
  },
};
</script>
